import { useState } from "react";
import { BiHide } from "react-icons/bi";
import { AiFillEye } from "react-icons/ai";
import useLogin from "../controllers/useLogin";

export default function Login() {
  const [hide, setHide] = useState(true);
  const {
    email,
    password,
    loading,
    handleEmailChange,
    handlePasswordChange,
    login,
  } = useLogin();
  return (
    <div className="  bg-gray-100 w-full h-[100vh] ">
      <div className=" backdrop-blur-lg bg-white w-fit shadow-lg  m-auto translate-y-10 rounded-md flex flex-col">
        <div className="flex space-x-10  p-10  ">
          <p className="font-Roboto text-sm tracking-wider mt-2">Enter email</p>
          <input
            type="email"
            className="p-2  border-[1px] border-black rounded-md"
            value={email}
            onChange={handleEmailChange}
          />
        </div>
        <div className="flex space-x-3  p-10 m-auto ">
          <p className="font-Roboto text-sm tracking-wider mt-2">
            Enter password
          </p>
          <div className="flex border-[1px] border-black p-1 rounded-md">
            <input
              type={hide ? "password" : "text"}
              className="rounded-sm p-1  outline-none"
              value={password}
              onChange={handlePasswordChange}
            />
            {hide ? (
              <BiHide
                className="mt-2 scale-150 cursor-pointer"
                onClick={() => setHide((prev) => !prev)}
              />
            ) : (
              <AiFillEye
                className="mt-2 scale-150 cursor-pointer"
                onClick={() => setHide((prev) => !prev)}
              />
            )}
          </div>
        </div>

        <div></div>
        <button
          className="bg-indigo-500 shadow-lg shadow-indigo-500/50 p-1 rounded-md font-Roboto font-bold text-white"
          disabled={loading}
          onClick={login}
        >
          Submit
        </button>
      </div>
    </div>
  );
}
